import React, { useState } from "react";
import SearchResults from "./searchResults";
import { Search, Clear } from "@material-ui/icons";
import { useDetectClickOutside } from "react-detect-click-outside";
import "./search-box.scss";

const SearchBox = (props) => {
  const [keySearch, setKeySearch] = useState("");
  const ref = useDetectClickOutside({
    onTriggered: () => {
      setKeySearch("");
      props.clearResults();
    },
  });
  const handleTextChange = (e) => {
    setKeySearch(e.target.value);
    if (e.target.value.length > 2) {
      props.debouncedSearch(e.target.value, true);
    } else if (e.target.value.length < 1) {
      setKeySearch("");
      props.clearResults();
    }
  };
  return (
    <div className="search-container">
      <div className="search-input-cell">
        <input
          value={keySearch}
          autoComplete="off"
          onChange={handleTextChange}
          type="text"
          name="search"
          id="search"
          placeholder="Search Address, City, Zip"
          className="search-cell-input-box"
          style={{ outline: "none" }}
        />
        <div className="search-cell-icon">
          {keySearch.length > 0 ? (
            <Clear
              onClick={() => {
                setKeySearch("");
                props.clearResults();
              }}
            />
          ) : (
            <Search />
          )}
        </div>
      </div>
      {Object.keys(props.results).length ? (
        <div className="search-results-list" ref={ref}>
          <SearchResults
            data={props.results}
            handleLocationChange={(data) => {
              setKeySearch(data.value);
              props.handleLocationChange(data);
            }}
            viewMoreListings={() => {
              props.handleLocationChange({
                key: "listingSearch",
                value: keySearch,
              });
            }}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/search/search-box/searchBox.jsx